import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input } from '@angular/core';

import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { BulkSelectionMessagesComponent } from '@recruitee/user-interface';

import { BulkActionsController } from '../bulk-actions.controller';
import { BulkActionsSelectionTracker } from '../bulk-actions.selection-tracker';

@Component({
  selector: 'rt-bulk-actions-selection-message',
  templateUrl: './bulk-actions-selection-message.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [BulkSelectionMessagesComponent],
})
export class BulkActionsSelectionMessageComponent {
  @Input() public hasBottomMargin: boolean = true;
  @Input() public hasTopMargin: boolean = true;

  public totalSelectedCount = 0;
  public currentViewSelectedCount = 0;

  private ngOnDestroy$ = new Subject<void>();

  constructor(
    private bulkCtrl: BulkActionsController,
    private tracker: BulkActionsSelectionTracker,
    protected cdRef: ChangeDetectorRef,
  ) {}

  public ngOnInit(): void {
    this.tracker.state$.pipe(takeUntil(this.ngOnDestroy$.asObservable())).subscribe(state => {
      this.totalSelectedCount = state.totalSelectedCount;
      this.currentViewSelectedCount = state.currentViewSelectedCount;
      this.cdRef.detectChanges();
    });
  }

  public ngOnDestroy(): void {
    this.ngOnDestroy$.next();
    this.ngOnDestroy$.complete();
  }

  public handleSelectionClear(): void {
    this.bulkCtrl.clearSelection();
  }
}
